import React from 'react'

export default function ErrorPage() {
    return (
        <div>
            <h1>Sorry , page not found</h1>
        </div>
    )
}
